import BulkAploadActions from './BulkAploadActions.component';

export default BulkAploadActions;